// extracted by mini-css-extract-plugin
export default {"postColumn":"GearView-styles__postColumn__kOVC2","headerIcon":"GearView-styles__headerIcon__nVH_M"};